import { useDispatch, useSelector } from "react-redux";
import { MDBModalBody, MDBModalFooter } from "mdb-react-ui-kit";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Icon } from "@iconify/react";
import {
  closePromotionModal,
  openGallery,
  openSendModal,
} from "../../../redux/reducer/modalReducer";
import { DefaultJustint } from "../../../assets/images";
import FullModal from "../../../components/modal/full.modal.box";
import useWindowDimensions from "../../../components/hook/use.window.dimensions";
import ModalHeader from "../../../components/header/modal.header";
import { setImageGallery } from "../../../redux/reducer/commonReducer";

export default function PromotionModal() {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  const { promotionList } = useSelector((state) => state.promotion);
  const { isOpenPromotionModal } = useSelector((state) => state.modal);

  const handleCloseModal = () => {
    dispatch(closePromotionModal());
  };

  const handleOpenGallery = (media) => {
    dispatch(openGallery());

    const gallery =
      media?.length > 0
        ? media.map((media) => {
            return {
              url: media.url,
              api_url: media.api_url,
              type: "image",
            };
          })
        : [];

    dispatch(setImageGallery(gallery));
  };

  const promotionInfo = promotionList.find(
    (promotion) => promotion.id === isOpenPromotionModal
  );

  return (
    <FullModal
      staticBackdrop={true}
      show={isOpenPromotionModal !== null}
      backButton={handleCloseModal}
      screenSize={width >= 770 ? "xl" : "fullscreen-xl-down"}
      className="overflow-hidden"
      dialogClassName="width-500"
      contentClassName="br-34"
      content={
        <>
          <ModalHeader
            className="br-34 fixed"
            backTo={handleCloseModal}
            title="Promotion Details"
          />
          <MDBModalBody className="vh-100">
            <article className="promotion-modal">
              <section
                className="promotion-frame"
                onClick={() => {
                  handleOpenGallery(promotionInfo.media);
                }}
              >
                <LazyLoadImage
                  src={
                    promotionInfo.media?.length > 0
                      ? promotionInfo.media[0].url
                      : DefaultJustint
                  }
                />
                <article
                  className="zoom-in"
                  onClick={() => {
                    handleOpenGallery(promotionInfo.media);
                  }}
                >
                  <Icon icon="ri:zoom-in-line" />
                </article>
              </section>
              <section className="promotion-info">
                <h6>{promotionInfo.name}</h6>
                {promotionInfo.start_at && promotionInfo.end_at && (
                  <span>
                    Valid from {promotionInfo.start_at} until{" "}
                    {promotionInfo.end_at}
                  </span>
                )}
                <p
                  className="desc"
                  dangerouslySetInnerHTML={{
                    __html: promotionInfo.description,
                  }}
                />
              </section>
            </article>
          </MDBModalBody>
          <MDBModalFooter
            className={`${width < 500 ? "mobile" : ""}`}
            style={{
              position: "fixed",
            }}
            onClick={() => {
              handleCloseModal();
              dispatch(openSendModal(isOpenPromotionModal));
            }}
          >
            <article className="footer-button">
              <h5>Send Promotion</h5>
            </article>
          </MDBModalFooter>
        </>
      }
    />
  );
}
